import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { gutil } from '../gutil';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import * as moment from 'moment';

@Component({
  selector: 'app-testimonials',
  templateUrl: './testimonials.component.html',
  styleUrls: ['./testimonials.component.scss']
})
export class TestimonialsComponent implements OnInit {

  public testimonial:Array<any>;
  public isReadMore:boolean = false;
  public faAngleRight = faAngleRight;
  public fetchTest:any;
  public userType:string;
  

  constructor(private http: HttpClient) { }

  ngOnInit(): void {
    window.scroll(0,0);
    this.fetchTest = 2;
    this.fetchTestimonials();
    this.userType = "Home Owner";
    
  }
  public testOf(value:any) {
    this.fetchTest = value;
    if(this.fetchTest == 1) {
      this.userType = "Tenant";
    }
    else {
      this.userType = "Home Owner";
    }
    this.fetchTestimonials();

  }
  public fetchTestimonials() {
    this.http.get(gutil.apiUrl + '/api/w/v1/testimony/details/' + this.fetchTest)
        .subscribe((data:any) => {
          this.testimonial = data.obj;
          for(let t = 0 ; t < this.testimonial.length ; t++ ){
            if(this.testimonial[t].image != null) {
              if(this.testimonial[t].image.length > 0) {
                for(let img = 0; img < this.testimonial[t].image.length; img++) {
                  if(this.testimonial[t].image[img].size == 'thb') {
                    this.testimonial[t].user_img = this.testimonial[t].image[img].url;
                  }
                }
              }
            }
            else {
              console.log("No image available");
            }
          }
          for(let x = 0; x < this.testimonial.length; x++) {
            this.testimonial[x].associated_since = moment(this.testimonial[x].created_at).format("D MMM YYYY");
          }
        })
  }
  public showText(value:number) {
    
    // document.getElementById('testimonial_'+value).classList.remove('limitTextHeight');
    // document.getElementById('testimonial_'+value).classList.add('fullTextHeight');

    if(document.getElementById('testimonial_' + value).classList.contains('limitTextHeight')){
      document.getElementById('testimonial_'+value).classList.remove('limitTextHeight');
      document.getElementById('testimonial_'+value).classList.add('fullTextHeight');
      document.getElementById("readMore_"+ value).innerHTML = "Read Less";

    }else{
      document.getElementById('testimonial_'+value).classList.add('limitTextHeight');
      document.getElementById('testimonial_'+value).classList.remove('fullTextHeight');
      document.getElementById("readMore_"+ value).innerHTML = "Read More";
    }
  }
}
